import ApiService from "../../helpers/ApiHelper";

class LogServices {

  static getLogs(payload) {
    let query = `?search=${JSON.stringify(payload.search)?JSON.stringify(payload.search):'1'}&page=${payload.page}`
    if (payload.q) {
      query += `&q=${encodeURIComponent(payload.q)}`
    }
    return ApiService.request(
      `/api/v2/logs/${query}`,
      'get',
      {}
    )
  }

  static getLog(id) {
    return ApiService.request(
      `/api/v2/logs/${id}`,
      'get',
      {}
    )
  }

}

export default LogServices
